window.addEventListener('DOMContentLoaded', async () => {
  const timestamp = Number(localStorage.getItem('timestamp') || 0)
  const now = Date.now()

  if( (now - timestamp) > 86400000) {
    try {
      console.info('running tasks')
      const res = await window.proficient.utils.runDailyTasks()
  
      if( res.status === 200 ) {
        console.info('daily tasks run successfully')
        localStorage.setItem('timestamp', now)
        return
      }
      console.info('running tasks: it wasn\'t necessary')
    } catch (error) {
      console.error(error)
      localStorage.setItem('timestamp', now)
    }
  }
})
